<template>
  <div v-if="ads" class="ads-item">
    <div v-show="isAdFilled" class="ads-borded">
      <div class="ads-borded-title">
        Advertisement
      </div>
      <!-- AdX广告容器 -->
      <div :id="ads.id" :style="getAdStyle()"></div>
    </div>
    <div v-show="showDebug" class="ad-msg">
      {{ ads }}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    ads: {
      type: [String, Object],
      required: false,
      default: null
    },
    showDebug: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      isAdFilled: true, // 默认显示
    }
  },
  mounted () {
    if (this.ads) {
      this.loadAdxAd()
    }
  },
  methods: {
    // 获取广告样式
    getAdStyle () {
      if (this.ads && this.ads.style) {
        return this.ads.style
      }
      return 'min-width: 300px; min-height: 250px;'
    },

    // 加载AdX广告
    loadAdxAd () {
      if (!window.googletag || !this.ads?.id) {
        setTimeout(() => this.loadAdxAd(), 200);
        return;
      }

      // 确保广告ID已在页面上创建
      const adElement = document.getElementById(this.ads.id);
      if (!adElement) {
        console.error(`广告元素 ${this.ads.id} 不存在`);
        return;
      }

      // 显示广告
      window.googletag.cmd.push(() => {
        try {
          console.log(`显示广告: ${this.ads.id}`);
          googletag.display(this.ads.id);
        } catch (error) {
          console.error(`显示广告 ${this.ads.id} 失败:`, error);
        }
      });
    }
  },
}
</script>